module.exports = __webpack_public_path__ + "media/50d.c25514c9.mp4";